export const inteligencia = [ 'TERMAN', 'BETAIIR', 'BETAIII', 'IE', 'RAVEN', 'DOMINOS', 'WONDERLIC', 'COIR']

export const comportamiento = [ 'CLEAVER', 'ESTILO', 'VALORES', 'VALORES COMP', 'MOSS', 'KOSTICK', 'ZAVIC', 'VALPER', 'LIFO', ]

export const personalidad = [ 'LUSCHER', 'CPI', 'PGV', 'BFQ', '16FP', 'PIP', 'IMP', 'PVC', 'NIC', ]
